import type { WallBoard } from '@walls/store';
import { DrawingCanvasLayer } from '../drawing/DrawingCanvasLayer';
import type { BoardRenderWindow } from '../viewport/renderWindow';

interface BoardCanvasLayerProps {
  board: WallBoard;
  renderWindow: BoardRenderWindow;
}

export function BoardCanvasLayer({ board, renderWindow }: BoardCanvasLayerProps) {
  return <DrawingCanvasLayer board={board} renderWindow={renderWindow} />;
}
